import React, { useMemo } from 'react';
import { usePermissionGate } from '@ubeya/shared/contexts/PermissionGateContext';

export const withPermissions = (WrappedComponent, requiredPermissions) => {
  const ProtectedComponent = ({ children, ...props }) => {
    const { actionPermissionGate, readPermissionGate } = usePermissionGate();

    // action and read are objects with type
    // { privileges : array of privileges,
    //  atLeastOneRequired?: boolean
    // }

    const permissions = useMemo(() => {
      const { action, read } = requiredPermissions;

      return {
        hasActionPermission: actionPermissionGate(action)(),
        hasReadPermission: readPermissionGate(read)
      };
    }, [actionPermissionGate, readPermissionGate]);

    if (!permissions.hasActionPermission && !permissions.hasReadPermission) {
      return <></>;
    }

    return (
      <WrappedComponent {...props} userPermissions={permissions}>
        {children}
      </WrappedComponent>
    );
  };

  return ProtectedComponent;
};

export default withPermissions;
